import React, { useEffect, useRef, useState } from "react";
import "../Style/Howwework.css";

import blueLogo from "../assets/blue-logo.png";

import planImg from "../assets/Plan.png";
import ideaImg from "../assets/Idea.png";
import strategyImg from "../assets/Strategy.png";
import processImg from "../assets/Process.png";

import thumb1 from "../assets/thumb1.png";
import thumb2 from "../assets/thumb2.png";
import thumb3 from "../assets/thumb3.png";
import thumb4 from "../assets/thumb4.png";


function Howwework() {
  const [activeCard, setActiveCard] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // animate once, on first scroll into view
        }
      },
      {
        // fires as soon as a sliver of the section enters view, so the
        // (now longer) animation has the full scroll distance to play out
        threshold: 0.03,
        rootMargin: "0px 0px -20px 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  const workCards = [
    {
      title: "Plan",
      step: "Step-1",
      quote: '"What are we really building - and why?"',
      image: planImg,
      backImage: thumb1,
    },
    {
      title: "Idea",
      step: "Step-2",
      quote: `"Let's solve the right problem..."`,
      image: ideaImg,
      backImage: thumb4,
    },
    {
      title: "Strategy",
      step: "Step-3",
      quote: '"Looks good is not enough. It must work."',
      image: strategyImg,
      backImage: thumb3,
    },
    {
      title: "Process",
      step: "Step-4",
      quote: '"We build, test, refine, and grow..."',
      image: processImg,
      backImage: thumb2,
    },
  ];

  return (

    <>


      {/* HOW WE WORK */}
      <section
        ref={sectionRef}
        className={`how-work-section ${isVisible ? "how-visible" : ""}`}
      >
        <h2 className="how-work-title">How We Work?</h2>

        <div className="how-work-intro">
          <div className="how-work-text">
            <h3>From Thought to Impact - Our Way</h3>
            <p>Every great product starts as a thought.</p>
            <p>
              We help that thought grow, evolve, and turn into something people
              actually love to use.
            </p>
          </div>

          <div className="how-work-logo-wrap">
            <img src={blueLogo} alt="logo" className="how-work-big-logo" />
          </div>
        </div>

        <div className="how-work-cards">
          {workCards.map((card, index) => (
            <div
              className="how-work-card"
              key={index}
              onMouseEnter={() => setActiveCard(index)}
              onMouseLeave={() => setActiveCard(null)}
            >
              <div className="how-work-image-box">
                <div
                  className={`how-work-front ${
                    activeCard === index ? "hide-front" : ""
                  }`}
                >
                  <img
                    src={card.image}
                    alt={card.title}
                    className="how-work-image"
                  />
                  <div className="how-work-overlay"></div>
                  <p className="how-work-quote">{card.quote}</p>
                </div>

                <div
                  className={`how-work-back ${
                    activeCard === index ? "show-back" : ""
                  }`}
                >
                  <img src={card.backImage} alt="back" className="how-work-image" />
                </div>
              </div>

              <h4>{card.title}</h4>
              <span>{card.step}</span>
            </div>
          ))}
        </div>
      </section>


    </>
  );
}

export default Howwework;